import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import Modal from '@mui/material/Modal';
import Snackbar from '@mui/material/Snackbar';

import { useTranslation } from 'react-i18next';

import './../../../Styles/Reels/Share.css';
import whatsup from './../../../../src/assets/whatsapp .png';
import twitter from './../../../../src/assets/twitter.png';
import facebook from './../../../../src/assets/facebook.png';
import telegram from './../../../../src/assets/telegram.png';
import CloseIcon from '../../../assets/svg/closeIcon';

function Share({ handleClose, open, url}) {
    const { t } = useTranslation();

    const [openBox, setOpenBox] = useState(false);

    const handleClickCopy = () => {
        setOpenBox(true);
    };

    const handleCloseCopy = (reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenBox(false);
    };

    let socialMediaShare = {
        whatsapp: 'https://api.whatsapp.com/send?text=' + url,
        facebook: 'https://facebook.com/sharer/sharer.php?u=' + url,
        twitter: 'https://twitter.com/share?url=' + url,
        telegram: 'https://telegram.me/share/url?url=' + url,
    };

    const sharePage = (site) => {
        window.open(socialMediaShare[site]);
    };

    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{
                    backdropFilter: 'blur(10px)',
                    backgroundColor: '#2C3142B2 !important',
                }}
            >
                <div className="reel-share-container">
                    <Box className="share-style">
                        <div className="share-and-crossIcon-container">
                            <Typography id="modal-modal-title" variant="h6" component="h2">
                                {t('reels.share-title')}
                            </Typography>
                            <CloseIcon onClick={() => handleClose()} className="cross-icon-location" />
                        </div>

                        <br />

                        <div className="share">
                            <button onClick={() => sharePage('whatsapp')} className="button">
                                <img className="img" src={whatsup} alt="whatsapp"></img>
                            </button>
                            <button onClick={() => sharePage('twitter')} className="button">
                                <img className="img" src={twitter} alt="twitter"></img>
                            </button>
                            <button onClick={() => sharePage('telegram')} className="button">
                                <img className="img" src={telegram} alt="telegram"></img>
                            </button>
                            <button onClick={() => sharePage('facebook')} className="button">
                                <img className="img" src={facebook} alt="facebook"></img>
                            </button>
                          
                        </div>

                        <div className="copy-text-container">
                            <input
                                className="copy-input"
                                contentEditable="false"
                                value={url}
                            ></input>

                            <CopyToClipboard text={url}>
                                <Button
                                    variant="contained"
                                    className="copy-button"
                                    onClick={() => handleClickCopy()}
                                >
                                    {t('reels.copy-title')}
                                </Button>
                            </CopyToClipboard>
                            <Snackbar
                                open={openBox}
                                autoHideDuration={2000}
                                onClose={handleCloseCopy}
                                message="Link Copied to clipboard"
                            />
                        </div>
                    </Box>
                </div>

            </Modal>
        </div>
    );
}

export default Share;
